<template>
  <div class="pt-1">
    <el-form label-position="right" class="mb-2" style="width: 100%; overflow-x: hidden !important">
      <el-row>
        <el-col>
          <question-type :title="'Question Type'" :field="field" />
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24" class="mt-1">
          <question-text :title="'Question Text'" :field="field" />
        </el-col>
      </el-row>
      <el-row>
        <el-col>
          <question-description :title="'Description'" :field="field" />
        </el-col>
      </el-row>
      <div class="flex items-center gap-3 pt-2">
        <span class="w-1/2">
          <field-filled-by class="w-full" :field="field" />
        </span>
        <span class="w-1/2">
          <question-number :field="field" />
        </span>
      </div>

      <el-row v-if="field.question_type == 'MCQ'">
        <el-col>
          <question-options
            :title="'Question Options'"
            :field="field"
            :standardQuestions="standardQuestions"
          />
        </el-col>
      </el-row>
      <el-row>
        <el-col>
          <div class="flex items-center gap-3 w-full">
            <div class="w-1/2">
              <is-field-required :field="field" />
            </div>
            <el-button type="text" class="w-1/2" @click="iconPickerdialogVisible = true">
              <div class="icon-dropdown-selection flex items-center !gap-3">
                <span
                  class="field-title-label !text-black-600 !text-xs 2xl:!text-sm !font-normal block !mb-1"
                >
                  Icon
                </span>
                <el-button type="text" @click="iconPickerdialogVisible = true">
                  <div class="d-flex align-center menu-icon !gap-2">
                    <span>
                      <icons :iconName="templateIconPath"></icons>
                    </span>
                    <i class="el-icon-circle-plus !text-brand-500"></i>
                  </div>
                </el-button>
              </div>
            </el-button>
          </div>
        </el-col>
      </el-row>
    </el-form>
    <dialog-component
      :title="'Select An Icon'"
      :visible="iconPickerdialogVisible"
      :containerWidth="getIsMobile ? '100%' : '77%'"
      @before-close="closeSelectIcon"
      :isShowFooter="false"
      :selectedIcon="field.icon_name"
    >
      <div class="icons-component">
        <div class="iconslistScrollable">
          <icons-list @icon-data="getIconPath"></icons-list>
        </div>
      </div>
    </dialog-component>
  </div>
</template>

<script>
  export default {
    name: 'Question',
    components: {
      IsFieldRequired: () => import('./IsFieldRequired'),
      FieldFilledBy: () => import('./FieldFilledBy'),
      QuestionType: () => import('./QuestionType'),
      QuestionText: () => import('./QuestionText'),
      QuestionDescription: () => import('./QuestionDescription'),
      QuestionNumber: () => import('./QuestionNumber'),
      QuestionOptions: () => import('./QuestionOptions'),
    },
    props: ['field', 'standardQuestions'],
    data() {
      return {
        templateIconPath: 'dashboard',
        iconPickerdialogVisible: false,
        validations: [],
        rowsOptions: [
          {
            title: 'Folder 1',
            _id: '1',
          },
          {
            title: 'Folder 2',
            _id: '2',
          },
          {
            title: 'Folder 3',
            _id: '3',
          },
        ],
      };
    },
    mounted() {
      if (this.field && this.field.icon_name) {
        this.templateIconPath = this.field.icon_name;
      }
    },
    methods: {
      closeSelectIcon() {
        this.iconPickerdialogVisible = false;
      },
      getIconPath(icon) {
        this.templateIconPath = icon;
        this.$set(this.field, 'icon_name', icon);
        this.iconPickerdialogVisible = false;
      },
    },
  };
</script>

<style lang="scss"></style>
